module.exports = __webpack_public_path__ + "img/xp-tb-games-omnichannel.2db32d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-games-omnichannel.png
// module id = 4y/Q
// module chunks = 38 43